export const articles = [
  {
    date: 'Oct 2026',
    title: "My Users Weren't Lying. They Just Couldn't Predict Themselves.",
    excerpt: 'What psychology taught me about the gap between what users say and what they do, and why design lives in that gap.',
    href: 'https://medium.com/design-bootcamp/my-users-werent-lying-they-just-couldn-t-predict-themselves-383f13140f1c',
  },
  {
    date: 'Apr 2026',
    title: 'I saw a woman on a train, and it changed how I think about design.',
    excerpt: "What happens when your user doesn't have a smartphone, a home, or a reason to trust you?",
    href: 'https://medium.com/design-bootcamp/i-saw-a-woman-on-a-train-and-it-changed-how-i-think-about-design-55eb8d94f3be',
  },
  {
    date: 'Nov 2025',
    title: 'Heuristic Evaluation in the Era of AI: Are the Old Rules Still Relevant?',
    excerpt: "Nielsen's heuristics were built for static systems. Where do they stand when the interface is generative and unpredictable?",
    href: 'https://medium.com/design-bootcamp/heuristic-evaluation-in-the-era-of-ai-are-the-old-rules-still-relevant-7586e9bcc4ee',
  },
  {
    date: 'Aug 2024',
    title: 'Designing for ADHD Users: A Psychology-Informed Approach.',
    excerpt: 'How cognitive load, working memory and impulsivity shape the way people with ADHD use digital products.',
    href: 'https://medium.com/design-bootcamp/designing-for-adhd-users-a-psychology-informed-approach-d2fc055d5e33',
  },
];

export const talks = [
  {
    when: 'Upcoming · Nov 2026',
    event: 'Friends of Figma',
    title: 'Behavioral design for AI products: why people trust, abandon or misuse them',
    description: 'A practical look at calibrated trust, and the interface patterns that earn it.',
  },
  {
    when: 'Feb 2026 · In Spanish',
    event: 'Design community talk',
    title: '¿La IA ya hace tu trabajo? ¿Qué haces tú que ella no puede?',
    description: 'What design practice looks like when AI can generate the screens.',
  },
];

export const sideProjects = [
  {
    title: 'Cognitive Biases in Product Design',
    description: 'A card deck that explains the biases behind everyday design decisions, with examples for product teams.',
    visual: 'cards' as const,
    href: '/playground/cognitive-biases',
    linkLabel: 'Open the deck',
    image: {
      src: 'https://cdn.magicpatterns.com/uploads/oT5cDoSBTnMaum5UjTZwZm/Edit-the-supplied-image-into-a-convincin.png',
      alt: 'The Cognitive Biases in Product Design deck: a black tin surrounded by colorful bias cards like Social Proof, Loss Aversion and Affect Heuristic',
      mono: false,
    },
  },
  {
    title: 'Motion & Illustration',
    description: 'Microinteractions, icons and motion studies, from Dribbble shots to brand illustration.',
    visual: 'motion' as const,
    comingSoon: true,
  },
  {
    title: 'Magic Patterns Ambassador',
    description: 'Helping designers prototype with AI through courses, demos and community sessions.',
    visual: 'prompt' as const,
    external: 'https://www.magicpatterns.com/profile/kat',
    linkLabel: 'See my Magic Patterns profile',
    image: {
      src: 'https://cdn.magicpatterns.com/uploads/pc89cMGvqZiYWefSX1kGKw/IMG_1608.jpg',
      alt: 'Kat speaking at a podium at Universidad EAFIT, in front of a slide reading "Memoria, no carpeta bonita"',
      mono: true,
    },
  },
];
